import routeMatcher from '@captaincodeman/router';
import { EventDetails } from "../pages/EventDetails.js";
import { EventsList } from "../pages/EventsList.js";
import { PublicSubmission } from "../pages/PublicSubmission.js";
import { RegistrationConfirmation } from "../pages/RegistrationConfirmation.js";
import { SeriesOverview } from "../pages/SeriesOverview.js";

// Currently unused, but this format can be used to pass custom params in routeMatcher
const gridView = {
    page: EventsList,
    params: {
        view: 'grid'
    }
}

/**
 * Format:
 * Route : page
 * 
 * Page can be either
 * 1. A class that extends ComponentBase
 * 2. An object with the following structure:
 *      {
 *          page: ComponentBaseClass,
 *          params: {
 *              *any values*
 *          }
 *      }
 * 
 *    Routes in this format are expanded in Router.js
 */
export default routeMatcher({
    '' : EventsList,
    '#' : EventsList,
    '#events(/:filters)' : EventsList,
    '#events/tag/:tag' : EventsList,
    '#events/search/(:query)' : EventsList,
    '#event-details/:id' : EventDetails,
    '#event-details/:id/series-overview' : SeriesOverview,
    '#event-details/:id/instances/:instanceId' : EventDetails, // instance ID is included in the URL for recurring events
    '#event-details/:id/attendee/:attendeeId/action/:action/code/:code' : RegistrationConfirmation,
    '#event-submission' : PublicSubmission,
    // support for non-hash URLs
    '/' : EventsList,
    '/events(/:filters)' : EventsList,
    '/events/tag/:tag' : EventsList,
    '/events/search/(:query)' : EventsList,
    '/event-details/:id' : EventDetails,
    '/event-details/:id/series-overview' : SeriesOverview,
    '/event-details/:id/instances/:instanceId' : EventDetails, // instance ID is included in the URL for recurring events
    '/event-details/:id/attendee/:attendeeId/action/:action/code/:code' : RegistrationConfirmation,
    '/event-submission' : PublicSubmission,
});